module.exports = __webpack_public_path__ + "img/index_middle-01@2x.ee4f1f86.png";